export const THEMES = [
  { id: "orbis", name: "Orbis Light", dark: false, swatch: ["#f5f8fb", "#2563eb", "#0f172a"] },
  { id: "binance", name: "Binance Dark", dark: true, swatch: ["#0b0e11", "#fcd535", "#181a20"] },
  { id: "nordic", name: "Nordic Slate", dark: false, swatch: ["#eef2f5", "#0f766e", "#1e293b"] },
  { id: "midnight", name: "Midnight Blue", dark: true, swatch: ["#0a1020", "#38bdf8", "#111a2e"] },
];
const KEY = "orbis_theme";

export function applyTheme(id) {
  const t = THEMES.find((x) => x.id === id) || THEMES[0];
  document.documentElement.dataset.theme = t.id;
  document.documentElement.classList.toggle("dark", t.dark);
  return t.id;
}

export function getTheme() {
  return localStorage.getItem(KEY);
}

export function setTheme(id) {
  localStorage.setItem(KEY, id);
  applyTheme(id);
  window.dispatchEvent(new Event("orbis-theme"));
}

export function initTheme(fallback = "orbis") {
  return applyTheme(getTheme() || fallback);
}
